import { WebTracerProvider } from '@opentelemetry/sdk-trace-web';
import { BatchSpanProcessor } from '@opentelemetry/sdk-trace-base';
import { OTLPTraceExporter } from '@opentelemetry/exporter-trace-otlp-http';
import { FetchInstrumentation } from '@opentelemetry/instrumentation-fetch';
import { UserInteractionInstrumentation } from '@opentelemetry/instrumentation-user-interaction';
import { XMLHttpRequestInstrumentation } from '@opentelemetry/instrumentation-xml-http-request';
import { registerInstrumentations } from '@opentelemetry/instrumentation';
import { resourceFromAttributes } from '@opentelemetry/resources';
import { ZoneContextManager } from '@opentelemetry/context-zone';
import CustomSpanProcessor from './custom-processor';
import { runInProduction } from '@/utils/runtime';

runInProduction(() => {
  const exporter = new OTLPTraceExporter({
    url: import.meta.env.VITE_OTEL_TRACES_ENDPOINT,
  });

  const provider = new WebTracerProvider({
    resource: resourceFromAttributes({
      'service.name': import.meta.env.VITE_OTEL_SERVICE_NAME,
      'deployment.environment': import.meta.env.VITE_OTEL_DEPLOYMENT_ENV,
    }),
    spanProcessors: [new BatchSpanProcessor(exporter), CustomSpanProcessor],
  });

  provider.register({
    contextManager: new ZoneContextManager(),
  });

  registerInstrumentations({
    instrumentations: [
      new FetchInstrumentation({
        // Selects which backend servers are allowed to receive trace headers for linking traces across services.
        // Using /.*/ acts as a wildcard. For safer usage in production, replace with specific domains:
        // e.g. propagateTraceHeaderCorsUrls: [/api\.example\.com/, /my-backend\.internal/]
        propagateTraceHeaderCorsUrls: [
          /https:\/\/portal\.ctrlplay\.com\.br\/(api\/)?api\/v1\/.*/g,
          /http:\/\/localhost:8000\/(api\/)?api\/v1\/.*/g,
        ],
      }),

      new XMLHttpRequestInstrumentation({
        propagateTraceHeaderCorsUrls: [
          /https:\/\/portal\.ctrlplay\.com\.br\/(api\/)?api\/v1\/.*/g,
          /http:\/\/localhost:8000\/(api\/)?api\/v1\/.*/g,
        ],
      }),

      new UserInteractionInstrumentation({
        eventNames: ['click', 'input', 'submit'],
      }),
      new XMLHttpRequestInstrumentation({
        propagateTraceHeaderCorsUrls: /.*/,
      }),
    ],
  });
});
